export default "__VITE_ASSET__7_wMTs4H__"